import { memo } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Popper } from '@m/alchemy-ui/Popper';
import { PopperBox } from '@m/alchemy-ui/PopperBox';
import { ArrowUpIcon } from '@m/alchemy-ui/icons/ArrowUpIcon';
import { ArrowDownIcon } from '@m/alchemy-ui/icons/ArrowDownIcon';
import { panelTypeOptions } from '../common/panel-types';
import {
  AddElementHint,
  AddElementItem,
  AddElementItemIcon,
  AddElementMenu as AddElementMenuList,
  AddElementTriggerContent,
  SecondaryButton
} from '../CustomPage.styled';

const messages = defineMessages({
  addElement: {
    id: 'editCustomPageAddElement',
    defaultMessage: 'Add element'
  },
  addElementHint: {
    id: 'editCustomPageAddElementHint',
    defaultMessage: 'Drag & drop the element on the page.'
  }
});

interface AddElementMenuProps {
  readonly onAddElement: (type: string) => void;
}

const AddElementMenuComponent = ({ onAddElement }: AddElementMenuProps) => {
  const intl = useIntl();

  return (
    <Popper
      placement="bottom-start"
      trigger={({ isOpen }) => (
        <SecondaryButton type="button" priority="secondary">
          <AddElementTriggerContent>
            {intl.formatMessage(messages.addElement)}
            {isOpen ? <ArrowUpIcon aria-hidden="true" /> : <ArrowDownIcon aria-hidden="true" />}
          </AddElementTriggerContent>
        </SecondaryButton>
      )}
      overlay={() => (
        <PopperBox hasArrow maxWidth={210}>
          <AddElementMenuList>
            <AddElementHint>{intl.formatMessage(messages.addElementHint)}</AddElementHint>
            {panelTypeOptions.map((option) => (
              <AddElementItem key={option.id} type="button" onClick={() => onAddElement(option.id)}>
                <AddElementItemIcon>{option.icon}</AddElementItemIcon>
                <span>{intl.formatMessage(option.message)}</span>
              </AddElementItem>
            ))}
          </AddElementMenuList>
        </PopperBox>
      )}
    />
  );
};

// Memoized so Formik state changes (e.g. typing the page title) don't re-render the menu;
// `onAddElement` must stay referentially stable (useCallback) in the parent.
export const AddElementMenu = memo(AddElementMenuComponent);
